import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {AuthGuard} from "../../common/auth-guard.service";
import {CommonMessagesService} from "../../services/common-messages.service";
import {MachineModelsService} from "../../services/machine-models.service";

@Component({
  selector: 'app-machine-model-list',
  templateUrl: './machine-model-list.component.html',
  styleUrls: ['./machine-model-list.component.scss']
})
export class MachineModelListComponent implements OnInit {

  @ViewChild("dataView")
  public dataView: any;

  public models: any;
  public totalModels: number;

  public rows: number = 9;
  public first: number = 0;

  public filtersVisible: boolean;
  public globalFilter: string;

  private loadingModels: boolean;


  constructor(private machineModelsService: MachineModelsService,
              public authGuard: AuthGuard,
              private confirmationService: ConfirmationService,
              private commonMessagesService: CommonMessagesService) {
  }

  ngOnInit(): void {
    this.loadModels();
  }

  resetFilters(): void {
    this.globalFilter = "";
    this.totalModels = this.models.length;
  }

  applyFilters(): void {
    this.dataView.filter(this.globalFilter.trim());
    this.totalModels = this.dataView.filteredValue.length;
    this.filtersVisible = false;
  }

  confirmAndDeleteSelected(uuid: string): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(uuid));
  }

  deleteSelected(uuid: string): void {
    this.machineModelsService.deleteModel(uuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadModels();
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  private loadModels(): void {
    this.loadingModels = true;
    this.machineModelsService.getModels()
      .subscribe(response => {
        this.models = response.models;
        this.totalModels = this.models.length;
        this.loadingModels = false;
      });
  }

}
